import styled from 'styled-components';
import {BGImageCenter, getStaticImage, scrollbar} from '../../../../globalVariables/GlobalVariables';
import {getPrimitive, getSpacing} from '@tickchak/react-share/app';
import {bottom} from '../../../../component/newPopup/innerPop/InnerPop.css';
import {title, close} from '../../../../component/newPopup/innerPop/InnerPop.css';
import {arrowDark} from '../../../../assets/symbols/symbols/Symbols.css';

const pricingImage = getStaticImage('subscriptions/priceForm.png');
export const pricingPop = styled.div`
    height: 100%;
    ${title}{
        color: ${getPrimitive('solids.black')};
    }
    ${close}{
        ${BGImageCenter(arrowDark ,'16px')}
    }
    ${bottom}{
        gap: ${getSpacing('spaceMd')};
    }
`;
export const header = styled.div`
    height: 180px;
    border-radius: 0 0 12px 12px;
    background-color: ${getPrimitive('turquoise.turquoise400')};
    ${BGImageCenter(pricingImage, '150px auto')}
`;

export const content = styled.div`
    height: calc(100% - 180px);
    padding: ${getSpacing('spaceLg')};
    padding-inline-start: 0px;
    ${scrollbar};
`;
